import Component from '../abstracts/Component';
import MenuItem from './header/MenuItem';
import TrackingComponent from './TrackingComponent';
import PriceRangeComponent from './PriceRangeComponent';
import ajaxAction from '../utils/ajaxUtil';
import {getFocusElement, hasFocusElement} from '../utils/BrowserHistoryUtils';

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      filterWrapper: '[data-filter-wrapper]',
      closeMenu: '[data-menu-close]',
      triggerMenu: '[data-menu-trigger]',
      filter: '[data-filter]',
      mobileFilter: '[data-mobile-filter]',
      dropdown: '[data-filter-dropdown]',
      benefitBar: '[data-benefit-bar]',
      listingHead: '[data-listing-head]',
      listingSearch: '[data-listing-search]',
      listing: '.c-listing',
      filterBar: '[data-filter-bar]',
      filterSort: '.js-sort-filter',
      resetCta: '[data-cta-reset]',
      applyCta: '[data-cta-apply]',
      input: '.w-f__bar-filters input[type="checkbox"]',
      mobileInput: '.w-f__menu input[type="checkbox"]',
      sortBy: '[data-sortby]',
      productsContainer: '[data-products-container]',
      resultsCount: '[data-result-count]',
      filtersInputs: '[data-filter-input]',
      menuMobile: '[data-menu-mobile]',
      menuMobileTitle: '[data-menu-mobile-title]',
      pageSalesFilters: '[data-page-sales]',
      layersContainer: '[data-menu-layers]',
      priceFilter: '[data-facet-code="rangePriceFilter"]',
      priceRangeActiveState: '.w-price-range.active',
      mobileFilterTitle: '.w-f__menu-filter-name',
      priceRangeComponent: '[data-js-component="PriceRangeComponent"]',
    };
  }

  get CLASSNAMES() {
    return {
      open: 'open',
      active: 'active',
      filteredState: 'filtered',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.body = document.querySelector('body');
    this.menuMobile = this.$component.querySelector(this.SELECTORS.menuMobile);
    this.menuMobileTitle = this.$component.querySelector(this.SELECTORS.menuMobileTitle);
    this.closeMenu = this.$component.querySelector(this.SELECTORS.closeMenu);
    this.triggerMenu = this.$component.querySelector(this.SELECTORS.triggerMenu);
    this.filterBar = this.$component.querySelector(this.SELECTORS.filterBar);
    this.filters = this.$component.querySelectorAll(this.SELECTORS.filter);
    this.mobileFilters = this.$component.querySelectorAll(this.SELECTORS.mobileFilter);
    this.resetCta = this.$component.querySelectorAll(this.SELECTORS.resetCta);
    this.applyCta = this.$component.querySelector(this.SELECTORS.applyCta);
    this.dropdowns = this.$component.querySelectorAll(this.SELECTORS.dropdown);
    this.listingHead = document.querySelector(this.SELECTORS.listingHead);
    if(!this.listingHead) {
      this.listingHead = document.querySelector(this.SELECTORS.listingSearch);
    }
    this.benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    this.listing = document.querySelector(this.SELECTORS.listing);
    this.inputs = this.$component.querySelectorAll(this.SELECTORS.input);
    this.mobileInputs = this.$component.querySelectorAll(this.SELECTORS.mobileInput);
    this.qs = new URLSearchParams(window.location.search);
    this.filtersInputs = document.querySelectorAll(this.SELECTORS.filtersInputs);
    this.sortBy = this.$component.querySelectorAll(this.SELECTORS.sortBy);
    this.productsContainer = document.querySelector(this.SELECTORS.productsContainer);
    this.resultsCount = document.querySelectorAll(this.SELECTORS.resultsCount);
    this.filterWrapper = document.querySelector(this.SELECTORS.filterWrapper);
    this.pageSalesFilters = document.querySelector(this.SELECTORS.pageSalesFilters);
    this.priceFilter = document.querySelector(this.SELECTORS.priceFilter);
    this.layersContainer = this.$component.querySelector(this.SELECTORS.layersContainer);
    if(this.layersContainer != null) this.layersContainer.style.transition = 'opacity .5s ease-in-out .2s';
    this.menuItems = [];
    // extra components
    this.TrackingComponent = new TrackingComponent();

    this.currentPriceRangeDom = null;
    this.ajaxAction = new ajaxAction();
    // base param
    this.sortName = 'sortBy';
    this.sortValue = 'topRated';
    // tracking variables
    this.sortMethod = '';
    this.sortType = '';
  }

  listenScroll() {
    if(this.listingHead) {
      window.addEventListener('scroll', () => {
        if(window.scrollY > this.returnOffsetHeight(this.benefitBar)) {
          let value = (100 - window.scrollY) / 100;
          let opacity = value > 0 ? value : 0;
          this.listingHead.style.opacity = opacity;
        } else {
          this.listingHead.style.opacity = 1;
        }
        this.fixFilters();
      });
    }
  }

  listenDropdown() {
    this.dropdowns.forEach(dropdown => {
      dropdown.addEventListener('click', e => {
        e.stopPropagation();
      });
    });
    this.filters.forEach(filter => {
      filter.addEventListener('click', () => this.dropdownHandler(filter));
    });
    document.addEventListener('click', e => {
      this.filters.forEach(filter => {
        let arrow = filter.querySelector('.down');
        if(e.target !== filter && e.target !== arrow) {
          filter.classList.remove(this.CLASSNAMES.open);
        }
      });
    });
  }

  listenModal() {
    let scrollY;
    // data-trigger-menu can be null
    if(this.triggerMenu != null && this.triggerMenu != 'undefined') {
      this.triggerMenu.addEventListener('click', () => {
        //show menu
        this.menuMobile.classList.add(this.CLASSNAMES.open);
        scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      });
    }
      this.closeMenu.addEventListener('click', () => {
        //hide menu
        this.menuMobile.classList.remove(this.CLASSNAMES.open);
        document.body.style.position = '';
        window.scrollTo(0, scrollY);
      });
      this.applyCta.addEventListener('click', () => {
        this.menuMobile.classList.remove(this.CLASSNAMES.open);
        document.body.style.position = '';
        window.scrollTo(0, scrollY);
        this.hideSecondLvlNav();
      });
    }

  // click on the filters
  listenSelected() {
    this.inputs.forEach(input => {
      input.addEventListener('change', () => {
        // launch filtering function
        this.filterQuery(input,false);
        // setting first query
        if(this.filterWrapper.getAttribute('data-first-filter') == null) {
          this.filterWrapper.setAttribute('data-first-filter',input.getAttribute('data-facet-code'));
        }
      });
    });
  }
  // listen for the sort desktop
  listenSort() {
    this.sortBy.forEach(singleSort => {
      singleSort.addEventListener('change', e => {
        // launch function
        this.filterQuery(singleSort);
        // mobile part
        this.menuMobile.querySelector('input[value=' + singleSort.value + ']').checked = true;
      });
    });
  }

  // MENU SETTING
  setActive() {
    // filter bar
    let filterBar = (typeof this.filterBar == 'undefined' || this.filterBar == null) ? document.querySelector(this.SELECTORS.filterBar) : this.filterBar;
    filterBar.classList.add(this.CLASSNAMES.active);
    // mobile menu
    let menuMobile = (typeof this.menuMobile == 'undefined' || this.menuMobile == null) ? document.querySelector(this.SELECTORS.menuMobile) : this.menuMobile;
    menuMobile.classList.add(this.CLASSNAMES.active);
    // reset btn
    let resetCta = (typeof this.resetCta == 'undefined' || this.resetCta == null) ? document.querySelectorAll(this.SELECTORS.resetCta) : this.resetCta;
    resetCta.forEach(input => {
      input.disabled = false;
    });
    // apply btn
    let applyCta = (typeof this.applyCta == 'undefined' || this.applyCta == null) ? document.querySelector(this.SELECTORS.applyCta) : this.applyCta;
    applyCta.disabled = false;
    // enable the function
    this.resetFilters();
  }

  setDisabled() {
    // filter bar
    let filterBar = (typeof this.filterBar == 'undefined' || this.filterBar == null) ? document.querySelector(this.SELECTORS.filterBar) : this.filterBar;
    filterBar.classList.remove(this.CLASSNAMES.active);
    // mobile menu
    let menuMobile = (typeof this.menuMobile == 'undefined' || this.menuMobile == null) ? document.querySelector(this.SELECTORS.menuMobile) : this.menuMobile;
    menuMobile.classList.remove(this.CLASSNAMES.active);
    // reset btn
    let resetCta = (typeof this.resetCta == 'undefined' || this.resetCta == null) ? document.querySelectorAll(this.SELECTORS.resetCta) : this.resetCta;
    resetCta.forEach(input => {
      input.disabled = true;
    });
    // apply btn
    let applyCta = (typeof this.applyCta == 'undefined' || this.applyCta == null) ? document.querySelector(this.SELECTORS.applyCta) : this.applyCta;
    applyCta.disabled = true;
  }

  fixFilters() {
    let scroll =
      this.returnOffsetHeight(this.listingHead) + this.returnOffsetHeight(this.benefitBar) + 1;
    if(window.scrollY > scroll) {
      this.$component.style.position = 'fixed';
      if(this.listing) {
        this.listing.style.paddingTop = `${this.$component.offsetHeight}px`;
      }
    } else {
      this.$component.style.position = '';
      if(this.listing) {
        this.listing.style.paddingTop = 0;
      }
    }
  }

  dropdownHandler(selectedFilter) {
    let activeFilter = this.$component.querySelector('[data-filter].open');
    if(activeFilter) {
      activeFilter.classList.remove(this.CLASSNAMES.open);
      if(selectedFilter !== activeFilter) {
        selectedFilter.classList.add(this.CLASSNAMES.open);
      }
    } else {
      selectedFilter.classList.add(this.CLASSNAMES.open);
    }
  }

  setMenuItems() {
    this.menuItems = [];
    let items = this.mobileFilters;

    if(items && items.length > 0) {
      items.forEach(item => {
        let menuItem = new MenuItem(item, this.layersContainer);
        this.menuItems.push(menuItem);
      });
    }
  }

  hideSecondLvlNav() {
    if(this.menuItems.length < 1) {
      return;
    }
    this.menuItems.forEach(menuItem => {
      menuItem.hidePanel();
    });
  }

  // filter the inputs after render
  filterInputsRender(inputsArr) {
    let filtersAvailableArr = [];
    // make an array of ids
    inputsArr.forEach(singleFilter => {
      filtersAvailableArr.push(singleFilter.id);
    });
    // cycle the page inputs
    let inputs = document.querySelectorAll(this.SELECTORS.input);
    inputs.forEach(singleInput => {
      if(this.filterWrapper.getAttribute('data-first-filter') != null && this.filterWrapper.getAttribute('data-first-filter') == singleInput.getAttribute('data-facet-code')) return false;
      // find the parent
      let dropdownParent = singleInput.closest(this.SELECTORS.dropdown);
      if(!dropdownParent.classList.contains(this.CLASSNAMES.active)) {
        // mobile input
        let mobileFilter = document.querySelector('#' + singleInput.id + '-mobile');
        // if included is enabled
        if(filtersAvailableArr.includes(singleInput.id)) {
          singleInput.disabled = false;
          if(typeof mobileFilter !== 'undefined') {
            mobileFilter.disabled = false;
          }
        } else {
          // if not included then disable it
          singleInput.disabled = true;
          if(typeof mobileFilter !== 'undefined') {
            mobileFilter.disabled = true;
          }
        }
      }
    });
  }

  priceFilterRender(target) {
    if(target == null) {
      this.$emit(this.$customEvents.PRICE_RANGE_FILTER.disable);
    } else {
      // price filter HTML structure update
      let priceFilterComponentEl = document.querySelector(this.SELECTORS.priceFilter);
      if (priceFilterComponentEl !== null) {
        priceFilterComponentEl.innerHTML = target.innerHTML;
      }
      // render of the PriceRangeComponent
      let priceRangeComponent = document.querySelector(this.SELECTORS.priceRangeComponent);
      if (priceRangeComponent !== null) {
        priceRangeComponent = new PriceRangeComponent(priceRangeComponent);
        priceRangeComponent.render();
      }
      this.$emit(this.$customEvents.PRICE_RANGE_FILTER.enable);
    }
  }

  // shows number of filters selected
  filterCounter() {
    // filter counter
    let filter_count;
    let hasPriceRangeActive = false;
    let total = 0;
    // cycle the filter
    this.filters.forEach(filter => {
      if(filter.classList.contains('sort')) return false;
      const currentPriceRangeActive = filter.querySelector(this.SELECTORS.priceRangeActiveState);
      if (!hasPriceRangeActive){
        hasPriceRangeActive = currentPriceRangeActive !== null;
      }
      let checkedInputs = filter.querySelectorAll('input[type=checkbox]:checked');
      const hasCheckedInputs = checkedInputs.length > 0;

      // if i have more
      filter.setAttribute('data-results', `${hasCheckedInputs ? checkedInputs.length : ''}`);
      filter.classList.toggle(this.CLASSNAMES.filteredState, (hasCheckedInputs || currentPriceRangeActive !== null));
      // mobile input
      let id = filter.getAttribute('data-facet-code');
      if(typeof id != 'undefined') {
        let mobileFilter = document.querySelector('[data-facet-code-mobile=' + id + ']');
        let mobileFilterPanel = document.querySelector('[data-facet-code-mobile][data-menu-panel=' + id + ']');
        const mobileCurrentPriceRangeActive = mobileFilterPanel ? mobileFilterPanel.querySelector(this.SELECTORS.priceRangeActiveState) : null;
        if (mobileFilterPanel && !hasPriceRangeActive){
          hasPriceRangeActive = mobileCurrentPriceRangeActive !== null;
        }
        if(typeof mobileFilter !== 'undefined') {
          let mobileFilterTitle = mobileFilter.querySelector(this.SELECTORS.mobileFilterTitle);
          mobileFilterTitle.setAttribute('data-results',`${hasCheckedInputs ? checkedInputs.length : ''}`);
          mobileFilterTitle.classList.toggle(this.CLASSNAMES.filteredState, (hasCheckedInputs || mobileCurrentPriceRangeActive !== null));
        }
      }

      total = hasCheckedInputs ? total + checkedInputs.length : total;
    });
    if (hasPriceRangeActive) {
      total = total + 1;
    }
    // activate bar
    if(total > 0) {
      this.setActive();
    }
    else {
      this.setDisabled();
    }
    // mobile total part
    if(typeof this.menuMobileTitle !== 'undefined' && this.menuMobileTitle !== null) this.menuMobileTitle.setAttribute('data-results', total);
  }

  // FILTERING FUNCTIONS

  // get the query params
  get QUERY_PARAMS() {
    return {
      originalurl:() => {
        return document.querySelector('[data-originalurl-remapped]').dataset.originalurlRemapped;
      },
      base:() => {
        if(document.body.classList.contains('t-search')) {
          return '?partial=true&save=false';
        }
        return '?save=false';
      },
      textSearch:() => {
        // following catches
        let q = '';
        if(this.qs.get('q') != null) {
          q = this.qs.get('q');
        } else if(this.qs.get('text') != null) {
          q = this.qs.get('text');
        }
        // on search page
        if(document.body.classList.contains('t-search')) {
          // other catches
          if(q != null) {
            let matchString = new RegExp('[^:]*', '');
            let search = q.match(matchString);
            return search[0];
          } else {
            return '';
          }
        }
        // on sale page
        if(document.body.classList.contains('t-sales') || this.pageSalesFilters != null) {
          if(q != null) {
            return q;
          } else {
            return '';
          }
        }
        return '';
      },
      sortBy:() => {
        // call sort from document to avoid pagination conflicts
        this.sortBy = document.querySelectorAll(this.SELECTORS.sortBy);
        // if there is no sort i exit
        if(typeof this.sortBy == 'undefined' || this.sortBy == null) return;
        // let's cycle the sorts
        this.sortBy.forEach(item => {
          // if i have checked the checkbox
          if(item.checked === true) {
            this.sortName = item.name;
            this.sortValue = item.value;
          }
        });
        // on sale page i dont want it because i already passed it
        if(this.pageSalesFilters != null) {
          return '';
        }

        return ':' + this.sortValue;
      },
      priceRange: () => {
        let priceQuery = '';
        const currentPriceRangeComponentJs = this.currentPriceRangeDom ? this.currentPriceRangeDom.component : null;
        if (!currentPriceRangeComponentJs) {
          return '';
        }
        priceQuery = currentPriceRangeComponentJs.buildQuery();
        return priceQuery;
      },
      formData: () => {
        // query
        let filterQuery = '';
        let isSales = false;
        // form inputs
        this.filtersInputs.forEach(input => {
          if(input.checked) {
            if(input.id.indexOf('inSales') !== -1) {
              isSales = true;
            }
            filterQuery = filterQuery + ':' + input.name + ':' + input.value;
            if(isSales == false) {
              filterQuery.replace('inSales:true:', '');
            }
          }
        });
        filterQuery = filterQuery + ':' + this.sortName + ':' + this.sortValue;

        return filterQuery;
      },
      pagination:(page) => {
        let paginationQueryBit = '';
        if(page) {
          // currentPage
          paginationQueryBit = '&page=' + page;
        }
        // if not cached
        return paginationQueryBit;
      },
    };
  }

  buildQuery(page = false) {
    let fullQuery =
      this.QUERY_PARAMS.originalurl() +
      this.QUERY_PARAMS.base() +
      '&isRefineSearch=true&q=' +
      this.QUERY_PARAMS.textSearch() +
      this.QUERY_PARAMS.sortBy() +
      this.QUERY_PARAMS.priceRange() +
      this.QUERY_PARAMS.formData() +
      this.QUERY_PARAMS.pagination(page);

    this.log('fullQuery ',fullQuery);

    return fullQuery;
  }

  // get page via ajax function
  getFilteredPage(query) {
    // get content
    return this.ajaxAction.getPage(query);
  }

  // render results
  renderPage(res, target, query = false) {
    // html response
    let response = new DOMParser().parseFromString(res, 'text/html');
    // render content
    this.ajaxAction.renderContent(res,'products');
    // emit events
    this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {
      response: response,
      res: res,
      query: query
    });
    // scroll to top
    window.scrollTo(0, 0);
  }

  // filter function
  filterQuery(input, page, query='') {
    let self = this;
    this.log('launch query');
    // start the filtering
    document.querySelector('body').classList.add('loading');
    // build the query
    if(query === '') {
      query = this.buildQuery(page);
    }
    // main products container
    let productsContainer = this.productsContainer;
    // get the page
    this.getFilteredPage(`${query}`).then(res => {
      let newURL = query.replace('isRefineSearch=true', 'isRefineSearch=false');
      if(this.body.classList.contains('t-salesV2-category')) {
        newURL = query;
      }
      // render the page
      self.renderPage(res, productsContainer, newURL);
      //tracking
      let response = new DOMParser().parseFromString(res, 'text/html');
      let products = response.querySelectorAll('[data-card]');
      if(input && input.dataset.sortbyName !== undefined) {
        let applyCta = typeof self.applyCta == 'undefined' || self.applyCta == null ? document.querySelector(self.SELECTORS.applyCta) : self.applyCta;
        let activeFilter = self.$component.querySelector('[data-filter].open');
        applyCta.disabled = false;
        if(activeFilter) activeFilter.classList.remove(self.CLASSNAMES.open);
        self.TrackingComponent.actions.sortTracking(input.dataset.sortbyName, this.sortMethod, this.sortType, products);
      } else {
        self.TrackingComponent.actions.filterTracking(input, products);
      }
      // set mobile
      if(typeof input !== 'undefined' && self.menuMobile != null && !self.menuMobile.classList.contains(self.CLASSNAMES.open)) {
        self.mobileInput(input);
      }
    });
  }

  // reset function
  resetFilters() {
    // bind the click
    this.resetCta.forEach(reset => {
      reset.addEventListener('click', () => {
        // cycle desktop inputs
        this.inputs.forEach(input => {
          // set input false
          input.checked = false;
        });
        // cycle mobile inputs
        this.mobileInputs.forEach(input => {
          // set input false
          input.checked = false;
        });
        // reset price range
        this.$emit(this.$customEvents.PRICE_RANGE_FILTER.reset);
        // reset first filter
        this.filterWrapper.setAttribute('data-first-filter', '');
        // launch void query
        this.filterQuery();
      });
    });
  }

  // MAIN EVENTS
  bindEvents() {
    // dom ready
    $(document).ready(() => {
      // filters form
      let checkedInputsForm = document.querySelectorAll('.w-f__bar-filters-layer input[type=checkbox]:checked');
      let $focusElement = $(getFocusElement());
      let handleFocus = hasFocusElement() && $focusElement.length > 0;
      // if the form is filled
      if(checkedInputsForm.length > 0 || document.querySelector('.w-price-range.active')) {
        // update filter bar
        this.filterCounter();
        this.setActive();
      }
      if(handleFocus) {
        this.timedOutScrollToElement($focusElement);
      }
    });

    // events
    // filter update
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      let sortBy = payload.response.querySelector(this.SELECTORS.filterSort);
      this.sortMethod = sortBy.dataset.sortMethod;
      this.sortType = sortBy.dataset.sortType;
      // put search results below search bar
      let numberProductsResponse = payload.response.querySelector(this.SELECTORS.resultsCount);
      if(this.resultsCount != null && numberProductsResponse != null) {
        this.resultsCount.forEach(item => {
          item.innerHTML = numberProductsResponse.innerHTML;
        });
      }
      // let's update the available filters
      let filtersAvailable = payload.response.querySelectorAll(this.SELECTORS.input);
      this.filterInputsRender(filtersAvailable);
      // refresh price filters
      let priceFilterResponse = payload.response.querySelector(this.SELECTORS.priceFilter);
      this.priceFilterRender(priceFilterResponse);
      // filter counter show
      this.filterCounter();
      // i cut the base query
      let newQs = payload.query.replace(this.QUERY_PARAMS.base() + '&', '?');
      // update the QS
      history.replaceState(null, null, newQs);
      // end filtering
      document.querySelector('body').classList.remove('loading');
    });

    this.$on(this.$customEvents.FILTERS_EVENTS.currentPriceRangeInput, ({event, payload}) => {
      this.currentPriceRangeDom = payload.domComponent ? payload.domComponent : null;
    });

    this.$on(this.$customEvents.FILTERS_EVENTS.launchQuery, () => {
      this.filterQuery();
    });
  }

  timedOutScrollToElement($element) {
    setTimeout(()=> {
      this.scrollToElement($element);
    }, 500);
  }

  scrollToElement($element) {
    $element.get(0).scrollIntoView({block: 'center', inline: 'nearest', behavior: 'smooth'});
  }

  returnOffsetHeight(element) {
    let offsetHeightVal = 0;
    if(element != null) {
      offsetHeightVal = element.offsetHeight;
    }
    return offsetHeightVal;
  }

  // MAIN RENDER
  render() {
    this.log('Rendering...');
    this.listenScroll();
    this.listenDropdown();
    this.listenModal();
    this.listenSelected();
    //sort
    this.listenSort();
    // main events
    this.bindEvents();
    // mobile
    this.mobileHandling();
    this.setMenuItems();
  }

  // mobile click goes to desktop click
  mobileHandling() {
    // all inputs
    let inputs = this.menuMobile.querySelectorAll('input[type=checkbox]');
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        // if the mobile menu is opened
        if(this.menuMobile.classList.contains(this.CLASSNAMES.open)) {
          // on click i search the desktop id
          let id = input.id;
          let new_id = id.replace('-mobile', '');
          let desktop_input = document.querySelector('#' + new_id);
          // simulate click on real filter
          desktop_input.click();
        }
      });
    });
    // sorting
    let sortRadio = this.menuMobile.querySelectorAll('input[type=radio]');
    sortRadio.forEach(sortRadio => {
      sortRadio.addEventListener('change', () => {
        // desktop radio
        this.filterBar.querySelector('input[value=' + sortRadio.value + ']').click();
      });
    });
  }

  // desktop click goes to mobile click
  mobileInput(input) {
    let id = input.id;
    //avoids exceptions on radio buttons ('data-sortby-name')
    if(typeof id == 'undefined' || $(input).attr('data-sortby-name') !== 'undefined') return false;
    let mobile_id = id + '-mobile';
    let mobile_input = document.querySelector('#' + mobile_id);
    mobile_input.checked = input.checked;
  }
}
